<template>
    <div id="app">
        <SiteHeader v-if="showGlobalLayout" />
        <router-view />
        <SiteFooter v-if="showGlobalLayout" />
        <div class="global-loading" v-show="isShowLoading">
            <Spin size="large"></Spin>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import SiteHeader from './components/SiteHeader.vue'
import SiteFooter from './components/SiteFooter.vue'

export default {
    name: 'App',
    components: { SiteHeader, SiteFooter },
    computed: {
        ...mapState([
            'isShowLoading',
        ]),
        showGlobalLayout() {
            const noLayout = ['login', 'register', '404']
            return !noLayout.includes(this.$route.name)
        },
    },
}
</script>

<style>
:root {
    --site-blue: #165eb4;
    --site-blue-dark: #0d4f99;
    --site-bg: #efefef;
    --site-card: #ffffff;
    --site-text: #2d2f33;
    --site-muted: #8a92a0;
    --site-border: #e6ebf2;
    --site-radius: 10px;
    --site-width: 1200px;
    --site-shadow: 0 2px 12px rgba(17, 80, 147, 0.08);
}

* {
    box-sizing: border-box;
}

html,
body,
#app {
    width: 100%;
    min-height: 100%;
}

html,
body {
    min-width: 1240px;
    overflow-x: auto;
}

#app {
    min-width: 1240px;
}

body {
    margin: 0;
    background: var(--site-bg);
    color: var(--site-text);
    font-family: 'Microsoft YaHei', 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
ul,
li,
div,
table {
    margin: 0;
    padding: 0;
}

li {
    list-style: none;
}

a {
    text-decoration: none;
    color: inherit;
}

.site-page {
    min-height: 100vh;
    padding-top: 0;
    min-width: 1240px;
    background: var(--site-bg);
}

.site-container {
    width: var(--site-width);
    min-width: var(--site-width);
    margin: 0 auto;
    padding: 0;
}

.section-card {
    background: var(--site-card);
    border-radius: var(--site-radius);
    box-shadow: var(--site-shadow);
}

.section-title {
    font-size: 24px;
    line-height: 1.2;
    font-weight: 700;
    color: var(--site-text);
}

.section-subtitle {
    margin-top: 8px;
    color: var(--site-muted);
    font-size: 13px;
}

.sub-page-banner {
    position: relative;
    z-index: 1;
    isolation: isolate;
    height: 260px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
}

.sub-page-banner::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 2;
    background: linear-gradient(90deg, rgba(21, 91, 175, 0.92) 0%, rgba(21, 91, 175, 0.66) 42%, rgba(21, 91, 175, 0.2) 100%);
}

.sub-page-banner .site-container {
    position: relative;
    z-index: 3;
    height: 100%;
    display: flex;
    align-items: center;
}

.sub-page-banner h1 {
    font-size: 48px;
    color: #fff;
    font-weight: 700;
    letter-spacing: 1px;
}

.float-tools {
    position: fixed;
    right: 30px;
    bottom: 180px;
    z-index: 30;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.float-tools .tool-btn {
    width: 34px;
    height: 34px;
    border: none;
    border-radius: 6px;
    background: linear-gradient(180deg, #3a87e2 0%, #2168c7 100%);
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(16, 82, 156, 0.25);
}

.float-tools .tool-btn:hover {
    background: linear-gradient(180deg, #2d79d7 0%, #175db8 100%);
}

.page-breadcrumb {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 16px;
    color: #9aa3b0;
    font-size: 13px;
}

.page-breadcrumb span {
    cursor: pointer;
}

.page-breadcrumb span.current {
    cursor: default;
    color: #7f8998;
}

.page-breadcrumb span.sep {
    cursor: default;
}

.tag-pill {
    height: 30px;
    border-radius: 15px;
    border: 1px solid transparent;
    background: #e8ebef;
    color: #737b88;
    font-size: 12px;
    padding: 0 22px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

.tag-pill:hover {
    border-color: #c6d5ea;
    color: #466281;
}

.tag-pill.active {
    background: var(--site-blue);
    color: #fff;
}

/* loading */
.global-loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
